export default "__VITE_ASSET__cw$eBhGA__"